import tw from 'twin.macro';
import { CaretIcon } from '@icons/CaretIcon';

const Wrapper = tw.div`flex justify-start items-center gap-[10px]`;
const ArrowButton = tw.button`flex items-center justify-center h-[28px] w-[28px] cursor-pointer`;
const PageButton = tw.button`flex justify-center items-center w-[25px] h-[25px] text-text-and-icon-muted text-[11px] font-medium`;

interface PaginationUIProps {
  currentPage: number;
  totalPages: number;
  paginationRange: (number | string)[];
  onPageChange: (page: number) => void;
  onNext: () => void;
  onPrevious: () => void;
}

// this component should be used in combination with usePagination hook, which provides the data and correct pagination range structure
export const Pagination = ({
  currentPage,
  totalPages,
  paginationRange,
  onPageChange,
  onNext,
  onPrevious,
}: PaginationUIProps) => {
  if (!totalPages || totalPages === 1) return null;

  return (
    <Wrapper>
      <ArrowButton onClick={onPrevious} disabled={currentPage === 1}>
        <CaretIcon css={[currentPage === 1 && tw`opacity-50`]} tw='fill-text-and-icon rotate-90' />
      </ArrowButton>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === '...') {
          return (
            <span tw='text-text-and-icon-muted' key={index}>
              {pageNumber}
            </span>
          );
        }
        return (
          <PageButton
            css={[
              currentPage === pageNumber &&
                tw`rounded border border-gray-1 bg-gray-2 text-text-and-icon`,
            ]}
            key={index}
            onClick={() => onPageChange(pageNumber as number)}
            disabled={currentPage === pageNumber}>
            {pageNumber}
          </PageButton>
        );
      })}
      <ArrowButton onClick={onNext} disabled={currentPage === totalPages}>
        <CaretIcon
          css={[currentPage === totalPages && tw`opacity-50`]}
          tw='fill-text-and-icon -rotate-90'
        />
      </ArrowButton>
    </Wrapper>
  );
};
